import React from "react";
import { Brightness4, Brightness5 } from '@mui/icons-material';
import { IconButton, useTheme } from "@mui/material";
import { useDispatch, } from "react-redux";
import { asyncToggleTheme } from "../store/reducers/themeSlice";

export default function ToggleColorMode() {
  const dispatch = useDispatch();

  const theme = useTheme();

  return (
    <>

      <IconButton
        sx={{ ml: 1 }}
        onClick={() => dispatch(asyncToggleTheme())}
        color="inherit"
      >
        {theme.palette.mode === "dark" ? (
          <Brightness4 sx={{ color: '#fff' }} />
        ) : (
          <Brightness5 />
        )}
      </IconButton>
    </>
  );

}